import { Button } from "@mui/material";
import { useState } from "react";
import { ActivityModal } from "../modal/ActivityModal";
import {
  useGetTaskActivitiesQuery,
  useGetOrgTaskActivitiesQuery,
} from "../../state/rtk-query/state/tasks";
import { useSelector } from "react-redux";
import { authSelectors } from "../../state";
import { useOrgId } from "../hooks";
import { skipToken } from "@reduxjs/toolkit/dist/query";

export function TaskActivityButton({ id }: { id?: number }) {
  const orgId = useOrgId();
  const isInternal = useSelector(authSelectors.isInternal);
  const [open, setOpen] = useState(false);
  const hook1 = useGetTaskActivitiesQuery(
    id && isInternal ? { id } : skipToken,
    {
      refetchOnMountOrArgChange: true,
    },
  );
  const hook2 = useGetOrgTaskActivitiesQuery(
    id && orgId ? { id, orgId } : skipToken,
    {
      refetchOnMountOrArgChange: true,
    },
  );
  const { data: { activities } = {} } = isInternal ? hook1 : hook2;
  if (!id) return null;
  if (!activities) return null;
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disabled={!activities.length}
        sx={{ p: 0, fontSize: 10, height: "15px", fontWeight: 600 }}
        disableRipple
      >
        {activities.length ? "View activity" : "No activity"}
      </Button>
      <ActivityModal
        id={id}
        open={open}
        setOpen={setOpen}
        activities={activities}
        type="task"
      />
    </>
  );
}
